module.exports = __webpack_public_path__ + "static/media/vermelho.9eb1aba2.svg";